import React from "react";
import "./Contact.css";
import arrow1 from "../../assets/arrow1.svg";
import arrow2 from "../../assets/arrow2u.svg";
import arrow3 from "../../assets/arrow3.svg";
import got from "../../assets/got.svg";
import guy from "../../assets/guy.svg";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <div className="contact-section">
      <div id="contact" className="contact">
        <img className="arrow1" alt="arrow" src={arrow1}></img>
        <img className="arrow2" alt="arrow" src={arrow2}></img>
        <img className="arrow3" alt="arrow" src={arrow3}></img>
        <div className="outt talk-ga">
          <Link to="/contact">
            <span className="got">
              <div className="cont">
                <span className="h1">
                  Let’s <strong>talk</strong>.
                </span>
                <span className="h5">Have Queries?</span>
              </div>
              <img className="im" alt="gotproject" src={got}></img>
            </span>
          </Link>
        </div>
        <img className="guy" alt="guy" src={guy}></img>
      </div>
    </div>
  );
};

export default Contact;
